import d from "./node_modules/nipplejs/src/index.js";export default d;